export default (value, options) => {
  if (!options) {
    return value
  }

  const option = options.find(option => option.value === value)

  return option != null ? option.name : value
}
